import * as React from 'react';

const ClosedSvg = () => (
  <svg width="11" height="7" viewBox="0 0 11 7" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M6.15204 6.03579C6.20195 6.00284 6.2493 5.9644 6.29323 5.92046C6.29323 5.92046 6.29323 5.92047 6.29323 5.92046L10.6773 1.5364C11.0288 1.18492 11.0288 0.615076 10.6773 0.263604C10.3258 -0.0878677 9.75598 -0.0878682 9.40451 0.263604L5.65683 4.01128L1.90917 0.263609C1.5577 -0.0878623 0.987848 -0.0878623 0.636376 0.26361C0.284904 0.615081 0.284904 1.18493 0.636376 1.5364L5.02044 5.92046C5.32798 6.228 5.80271 6.26644 6.15204 6.03579Z" fill="#020509" fillOpacity="0.6"/>
</svg>

  
  
);

export default ClosedSvg;
